import { defineStore } from 'pinia';

import { getCurrentUser } from '../api/auth';
import { clearToken, getToken, getUserCache, setToken, setUserCache } from '../utils/auth';

export const useUserStore = defineStore('user', {
  state: () => ({
    token: getToken(),
    profile: getUserCache()
  }),
  getters: {
    displayName(state) {
      return state.profile?.name || state.profile?.username || '未登录用户';
    },
    isAdmin(state) {
      return state.profile?.type === 'admin';
    },
    isEnterprise(state) {
      return state.profile?.type === 'enterprise';
    },
    roleLabel(state) {
      return state.profile?.type === 'admin' ? '管理员' : '企业用户';
    }
  },
  actions: {
    setSession(token, profile) {
      this.token = token;
      this.profile = profile;
      setToken(token);
      setUserCache(profile);
    },
    setProfile(profile) {
      this.profile = profile;
      setUserCache(profile);
    },
    async refreshProfile() {
      if (!this.token) return null;

      try {
        const result = await getCurrentUser();
        this.setProfile(result.data);
        return result.data;
      } catch (error) {
        this.logout();
        throw error;
      }
    },
    logout() {
      this.token = '';
      this.profile = null;
      clearToken();
    }
  }
});
